module.exports = __webpack_public_path__ + "static/media/spoonerism-task (3).5e55acbc.mp3";